import { render, staticRenderFns } from "./CommonSettingLayout.vue?vue&type=template&id=4e13e0ee&scoped=true&"
import script from "./CommonSettingLayout.vue?vue&type=script&lang=js&"
export * from "./CommonSettingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13e0ee",
  null
  
)

export default component.exports